// PipelineDuration.js
//
// Canonical pipeline option SLA unit: whole days (null = no target).

/**
 * Normalizes a pipeline option target duration to whole days, or null.
 *
 * @param {unknown} value
 * @returns {number|null}
 */
export function normalizeTargetDurationDays(value) {
  if (value == null || value === '') return null;
  const numeric = typeof value === 'number' ? value : Number(String(value).trim());
  if (!Number.isFinite(numeric)) return null;
  const days = Math.round(numeric);
  if (days <= 0) return null;
  return days;
}

/**
 * Formats days for option editor inputs.
 *
 * @param {unknown} value
 * @returns {string}
 */
export function formatTargetDurationDaysInput(value) {
  const days = normalizeTargetDurationDays(value);
  return days == null ? '' : String(days);
}
